export default "__VITE_ASSET__NwMeYcqo__"